export async function FETCH_SETTINGS({ commit }) {
  const response = await this.$alfredService.fetchPublicSettings();
  commit("SET_SETTINGS", response);
}

export async function SET_SHOW_UPLOAD_MODAL({ commit }, value) {
  commit("SET_SHOW_UPLOAD_MODAL", value);
}

export async function SET_ADMIN_STATS_DATE({ commit }, value) {
  commit("SET_ADMIN_STATS_DATE", value);
}

export async function FETCH_SYSTEM_BANNER({ commit }) {
  // Errors are swallowed on purpose: the status endpoint is polled on every page,
  // and a failure there must never surface to the user or block rendering.
  try {
    const response = await this.$alfredService.getSystemStatusUser();
    commit("SET_SYSTEM_BANNER", response?.banner || null);
  } catch (e) {
    commit("SET_SYSTEM_BANNER", null);
  }
}
